import { defineStore } from 'pinia'
import { ref, computed, toRaw } from 'vue'

export const useAccountStore = defineStore(
    'account',
    () => {
        const accounts = ref([])
        const currentAccount = ref(0)

        const getAccounts = computed(() => toRaw(accounts.value))
        const getCurrentAccount = computed(() => toRaw(accounts.value)[currentAccount.value])

        function setAccounts(newAccounts) {
            accounts.value = newAccounts
        }

        function setCurrentAccount(accountIndex) {
            currentAccount.value = toRaw(accounts.value)[accountIndex]
        }

        function clear() {
            accounts.value = []
            currentAccount.value = 0
        }

        return {
            accounts,
            currentAccount,
            getAccounts,
            getCurrentAccount,
            setAccounts,
            setCurrentAccount,
            clear,
        }
    },
    {
        persist: true
    }
)
